// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardStepIconRelay = require("./PropertyWizardStepIconRelay.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts = require("./PropertyWizardFormRelay__Validators__KeyFacts.bs.js");
var PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
var PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
var PropertyWizardRelayNavigation_formState_graphql = require("../../../__generated__/PropertyWizardRelayNavigation_formState_graphql.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayNavigation_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayNavigation_localDraft_graphql.bs.js");
var PropertyWizardFormRelay__Validators__PhotosAndFiles = require("./PropertyWizardFormRelay__Validators__PhotosAndFiles.bs.js");

function PropertyWizardRelayNavigation$Holder(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "bg-zinc-50 border-b border-zinc-200 p-0 sm:pt-6 sm:pb-2.5 sm:px-0 sm:mb-5 lg:pt-9 lg:pb-2.5 lg:px-12 lg:mb-0"
            });
}

var Holder = {
  make: PropertyWizardRelayNavigation$Holder
};

function style(active) {
  return TailwindMerge.twMerge([
              "text-center relative w-full flex-1 \n         before:content-[''] before:absolute before:left-0 before:right-1/2 before:top-6 before:h-0.5 \n         after:content-[''] after:absolute after:left-1/2 after:right-0 after:top-6 after:h-0.5 \n         first:before:bg-zinc-50 last:after:bg-zinc-50",
              "max-sm:p-2.5 max-sm:border-b max-sm:border-zinc-200 max-sm:last:border-b-0 max-sm:before:hidden max-sm:after:hidden max-sm:[&>a]:flex max-sm:[&>a]:items-center",
              active ? "max-sm:border-b-0 max-sm:[&~li]:hidden" : ""
            ]);
}

var Style = {
  style: style
};

var WizardStep = {
  Style: Style
};

function PropertyWizardRelayNavigation$List(props) {
  return JsxRuntime.jsx("ul", {
              children: props.children,
              className: "list-none flex justify-between w-full pl-0 relative \n         before:content-[''] before:absolute before:left-0 before:right-0 before:top-6 before:h-0.5 before:bg-zinc-300 \n         mb-4 max-sm:flex-col max-sm:mb-0 max-sm:before:hidden"
            });
}

var List = {
  make: PropertyWizardRelayNavigation$List
};

function PropertyWizardRelayNavigation$ListItem(props) {
  var selectStep = props.selectStep;
  var markStepAsTouched = props.markStepAsTouched;
  var activeStep = props.activeStep;
  var step = props.step;
  var wrapInTouchedOrActive = function (innerState, step) {
    if (activeStep === step) {
      return {
              NAME: "active",
              VAL: innerState
            };
    } else {
      return {
              NAME: "touched",
              VAL: innerState
            };
    }
  };
  return JsxRuntime.jsx("li", {
              children: JsxRuntime.jsx(PropertyWizardStepIconRelay.make, {
                    stepNumber: props.stepNumber,
                    icon: props.icon,
                    label: props.label,
                    stepState: props.stepTouched ? (
                        props.stepValid ? wrapInTouchedOrActive("valid", step) : wrapInTouchedOrActive("invalid", step)
                      ) : (
                        activeStep === step ? ({
                              NAME: "active",
                              VAL: "unknown"
                            }) : "untouched"
                      ),
                    active: activeStep === step,
                    onClick: (function (e) {
                        e.preventDefault();
                        markStepAsTouched();
                        selectStep(step);
                      })
                  }),
              className: style(activeStep === step)
            });
}

var ListItem = {
  make: PropertyWizardRelayNavigation$ListItem
};

var convertFragment = PropertyWizardRelayNavigation_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayNavigation_localDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayNavigation_localDraft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayNavigation_localDraft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayNavigation_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayNavigation_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function stepValid(valid) {
  return valid !== "Invalid";
}

function PropertyWizardRelayNavigation(props) {
  var activeStep = props.activeStep;
  var selectStep = props.selectStep;
  var match = PropertyWizardFormRelay.Context.use();
  var draft = use(props.draft);
  var formState = use$1(props.formState);
  var updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  var keyFactsValid = PropertyWizardFormRelay__Validators__KeyFacts.use(draft.fragmentRefs, formState.fragmentRefs);
  var descriptionValid = PropertyWizardFormRelay__Validators__Description.use(draft.fragmentRefs, formState.fragmentRefs);
  var mlsTimingValid = PropertyWizardFormRelay__Validators__MLSTiming.use(draft.fragmentRefs, formState.fragmentRefs);
  var showingsValid = PropertyWizardFormRelay__Validators__Showings.use(draft.fragmentRefs);
  var photosAndFilesValid = PropertyWizardFormRelay__Validators__PhotosAndFiles.use(formState.fragmentRefs);
  var markStepAsTouched = function () {
    updateFormState(function (formState) {
          if (activeStep === "description") {
            formState.stepDescriptionTouched = true;
          } else if (activeStep === "mlsTiming") {
            formState.stepMlsTimingTouched = true;
          } else if (activeStep === "photosAndFiles") {
            formState.stepPhotosAndFilesTouched = true;
          } else if (activeStep === "keyFacts") {
            formState.stepKeyFactsTouched = true;
          } else {
            formState.stepShowingsTouched = true;
          }
        });
  };
  var tmp;
  var tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" || tmp$1.TAG !== "Rebroadcast" ? "Description" : "Message";
  var match$1 = draft.draftProperty.propertyType;
  var tmp$2;
  tmp$2 = match$1 === "FOR_SALE" ? JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
          step: "showings",
          activeStep: activeStep,
          icon: "Eye",
          label: "Showings",
          stepTouched: formState.stepShowingsTouched,
          stepValid: showingsValid !== "Invalid",
          stepNumber: 4,
          markStepAsTouched: markStepAsTouched,
          selectStep: selectStep
        }) : null;
  return JsxRuntime.jsx(PropertyWizardRelayNavigation$Holder, {
              children: JsxRuntime.jsxs(PropertyWizardRelayNavigation$List, {
                    children: [
                      JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
                            step: "keyFacts",
                            activeStep: activeStep,
                            icon: "File",
                            label: "Key facts",
                            stepTouched: formState.stepKeyFactsTouched,
                            stepValid: keyFactsValid !== "Invalid",
                            stepNumber: 1,
                            markStepAsTouched: markStepAsTouched,
                            selectStep: selectStep
                          }),
                      JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
                            step: "mlsTiming",
                            activeStep: activeStep,
                            icon: "Clock",
                            label: "MLS timing",
                            stepTouched: formState.stepMlsTimingTouched,
                            stepValid: mlsTimingValid !== "Invalid",
                            stepNumber: 2,
                            markStepAsTouched: markStepAsTouched,
                            selectStep: selectStep
                          }),
                      JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
                            step: "description",
                            activeStep: activeStep,
                            icon: "Pencil",
                            label: tmp,
                            stepTouched: formState.stepDescriptionTouched,
                            stepValid: descriptionValid !== "Invalid",
                            stepNumber: 3,
                            markStepAsTouched: markStepAsTouched,
                            selectStep: selectStep
                          }),
                      tmp$2,
                      JsxRuntime.jsx(PropertyWizardRelayNavigation$ListItem, {
                            step: "photosAndFiles",
                            activeStep: activeStep,
                            icon: "Image",
                            label: "Photos & files",
                            stepTouched: formState.stepPhotosAndFilesTouched,
                            stepValid: photosAndFilesValid !== "Invalid",
                            stepNumber: 5,
                            markStepAsTouched: markStepAsTouched,
                            selectStep: selectStep
                          })
                    ]
                  })
            });
}

var Icon;

var FormState;

var Utils;

var Step;

var Validators;

var make = PropertyWizardRelayNavigation;

exports.Icon = Icon;
exports.FormState = FormState;
exports.Utils = Utils;
exports.Step = Step;
exports.Holder = Holder;
exports.WizardStep = WizardStep;
exports.List = List;
exports.ListItem = ListItem;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Validators = Validators;
exports.stepValid = stepValid;
exports.make = make;
/* tailwind-merge Not a pure module */
